// Offline utilities for queueing and syncing submissions

const OFFLINE_QUEUE_KEY = 'offline-submission-queue';

// Check if we're online
export const isOnline = () => {
  return navigator.onLine;
};

// Get the offline queue
export const getOfflineQueue = () => {
  try {
    const queue = localStorage.getItem(OFFLINE_QUEUE_KEY);
    return queue ? JSON.parse(queue) : [];
  } catch (e) {
    console.error('Failed to get offline queue:', e);
    return [];
  }
};

// Add item to offline queue
export const addToOfflineQueue = (payload) => {
  try {
    const queue = getOfflineQueue();
    const item = {
      id: Date.now().toString(),
      payload,
      timestamp: new Date().toISOString(),
      retries: 0
    };
    queue.push(item);
    localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(queue));
    return item;
  } catch (e) {
    console.error('Failed to add to offline queue:', e);
    return null;
  }
};

// Remove item from offline queue
export const removeFromOfflineQueue = (id) => {
  try {
    const queue = getOfflineQueue();
    const filtered = queue.filter(item => item.id !== id);
    localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(filtered));
  } catch (e) {
    console.error('Failed to remove from offline queue:', e);
  }
};

// Clear the offline queue
export const clearOfflineQueue = () => {
  try {
    localStorage.removeItem(OFFLINE_QUEUE_KEY);
  } catch (e) {
    console.error('Failed to clear offline queue:', e);
  }
};

// Update retry count for an item
export const updateQueueItemRetries = (id) => {
  try {
    const queue = getOfflineQueue();
    const updated = queue.map(item => {
      if (item.id === id) {
        return { ...item, retries: (item.retries || 0) + 1 };
      }
      return item;
    });
    localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(updated));
  } catch (e) {
    console.error('Failed to update queue item:', e);
  }
};

// Register service worker
export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      });


      // Handle updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New version available
          }
        });
      });

      return registration;
    } catch (error) {
      console.error('Service Worker registration failed:', error);
      return null;
    }
  }
  return null;
};

// Listen for messages from service worker
export const setupServiceWorkerListener = (onMessage) => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SYNC_OFFLINE_QUEUE') {
        onMessage(event.data);
      }
    });
  }
};

// Request background sync
export const requestBackgroundSync = async () => {
  if ('serviceWorker' in navigator && 'SyncManager' in window) {
    try {
      const registration = await navigator.serviceWorker.ready;
      await registration.sync.register('sync-submissions');
      return true;
    } catch (e) {
      console.error('Background sync registration failed:', e);
      return false;
    }
  }
  return false;
};
